import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import LargeSophisticatedTooltipHeading from '../LargeSophisticatedTooltipHeading';
import SophisticatedTooltipText from '../SophisticatedTooltipText';
import s from './LargeSophisticatedTooltipContent.scss';
/**
 * Lays out the content for our large sophisticated tooltips.
 *
 * Either `heading` or `aria-label` is required so a11y software will know what the tooltip is for.
 */ const LargeSophisticatedTooltipContent = (_param)=>{
    var { description , prefix , postfix  } = _param, labelOrHeading = _object_without_properties(_param, [
        "description",
        "prefix",
        "postfix"
    ]);
    // We won't always use this because we also accept `aria-label` in place of `heading` for a11y.
    const headingId = useUniqueId();
    const heading = labelOrHeading.heading;
    const ariaLabel = labelOrHeading['aria-label'];
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        role: "dialog",
        "aria-labelledby": heading ? headingId : undefined,
        "aria-label": ariaLabel ? ariaLabel : undefined
    }, prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), /*#__PURE__*/ React.createElement("div", {
        className: s['text-block']
    }, heading && /*#__PURE__*/ React.createElement(LargeSophisticatedTooltipHeading, {
        id: headingId
    }, heading), description && /*#__PURE__*/ React.createElement(SophisticatedTooltipText, null, description), postfix));
};
LargeSophisticatedTooltipContent.displayName = 'LargeSophisticatedTooltipContent';
export default LargeSophisticatedTooltipContent;
